import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaDbDa.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(DM)$/.test(type)
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'DM'},
            ]
        },

        _fixChild(map, node, child) {
            return map.BizNode.DM._fixChild(map, node, child)
        },
    })
}
